import script from "./SetupApptTypeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupApptTypeCard.vue?vue&type=script&setup=true&lang=js"

import "./SetupApptTypeCard.vue?vue&type=style&index=0&id=7a0e452a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0e452a"]])

export default __exports__